<template>
  <div>
    <div class="columns">
      <div class="column">
        <p class="title is-4 has-text-darkblue">{{ title }}</p>
      </div>
    </div>

    <div v-if="!isEmpty($slots.head)" class="columns">
      <div class="column">
        <slot name="head"></slot>
      </div>
    </div>

    <div class="box is-boxed-3">
      <slot name="box_head"></slot>

      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th :class="!isEmpty(h.class) ? h.class : ''" :style="!isEmpty(h.style) ? h.style : ''" v-for="(h, key) in header" :key="key">
              <a href="" @click.prevent="sortBy(h)" v-if="!isEmpty(sort) && h.sort">
                <div class="columns is-mobile">
                  <div class="column is-narrow"><span class="has-text-dark">{{ h.text }}</span></div>
                  <div class="column" v-if="sort.criteria == h.value">
                    <i v-if="sort.order.toLowerCase() == 'asc'" class="fas fa-angle-up"></i>
                    <i v-else class="fas fa-angle-down"></i>
                  </div>
                </div>
              </a>
              <span class="has-text-dark" v-else>{{ h.text }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading_get_refresh">
            <td :colspan="header.length"><spinner-loading></spinner-loading></td>
          </tr>
          <tr v-if="!loading_get_refresh && !isEmpty(body)" v-for="(b, b_key) in body" :key="b_key">
            <td v-for="(h, h_key) in header" :key="h_key" :class="!isEmpty(h.class) ? h.class : ''" :style="!isEmpty(h.style) ? h.style : ''">
              <div v-if="!isEmpty(h.value) && h.value == 'actions'" class="dropdown is-hoverable" @click.prevent="">
                <div class="dropdown-trigger">
                  <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
                    <span class="icon is-small">
                      <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <a href="#" class="dropdown-item" v-for="(a, a_key) in b.actions" @click.prevent="a.onclick($event, b)" :key="a_key">
                      <span class="icon" v-if="!isEmpty(a.icon)">
                        <i :class="a.icon"></i>
                      </span>
                      <span v-html="a.text"></span>
                    </a>
                  </div>
                </div>
              </div>
              <div v-else>
                <span v-if="b.is_html" v-html="b[h.value]"></span>
                <span v-else>{{ b[h.value] || "-" }}</span>
              </div>
            </td>
          </tr>
          <tr v-if="!loading_get_refresh && !isEmpty(body)">
            <td :colspan="header.length">
              <pagination :dataProvider="dataProvider" :clickHandler="() => $emit('onLoad')" :infinity_scroll="true"></pagination>
            </td>
          </tr>
          <tr v-if="!loading_get_refresh && !loading_get && isEmpty(body)">
            <td class="has-text-grey font-14 has-text-centered" :colspan="header.length">Data tidak ditemukan</td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading_get">
        <spinner-loading></spinner-loading>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading_get: {
      type: Boolean,
      default: false
    },
    loading_get_refresh: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    header: {
      type: Array,
      default: () => []
    },
    body: {
      type: Array,
      default: () => []
    },
    dataProvider: {
      type: Object,
      default: () => {
        return {
          page: { current: 1, limit: 15, total: 0 },
          criterion: [],
          order: [
            { criteria: 'created_at', order: 'desc' }
          ]
        }
      }
    },
    clickHandler: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    sort() {
      return collect(this.dataProvider.sort).first();
    }
  },

  methods: {
    sortBy(header) {
      const vm = this
      let order = this.sort.order.toLowerCase() == 'asc' ? 'desc' : 'asc';
      let sort = {criteria: header.value, order};

      if (header.sort_no_table) {
        sort['no_table'] = true
      }

      this.dataProvider.sort = [sort];
      this.clickHandler(true);
    }
  }
}
</script>
